import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

// Protected route that requires authentication
export const ProtectedRoute = ({ requireVerification = true }) => {
  const { currentUser } = useAuth();
  
  // If not logged in, redirect to sign in
  if (!currentUser) {
    return <Navigate to="/signin" replace />;
  }
  
  // If verification is required and user is not verified, redirect to verification page
  if (requireVerification && !currentUser.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  // If authenticated (and verified if required), render the route
  return <Outlet />;
};

// Route that is only accessible when NOT logged in
export const PublicOnlyRoute = () => {
  const { currentUser } = useAuth();
  
  // If logged in, redirect to dashboard
  if (currentUser) {
    if (!currentUser.emailVerified) {
      return <Navigate to="/verify-email" replace />;
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  }
  
  // If not logged in, allow access
  return <Outlet />;
};